import { NAV_ITEMS } from '@/constants';
import { useRootTab } from '@/utils/hooks/useRootTab';
import ArrowLeftLineIcon from '@rsuite/icons/ArrowLeftLine';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { IconButton, IconButtonProps } from 'rsuite';

interface BackButtonProps extends Omit<IconButtonProps, 'onClick'> {
  label?: string;
  doNotGoBack?: boolean;
  dataCy?: string;
}

export function BackButton(props: BackButtonProps) {
  const { label, doNotGoBack, dataCy, ...otherProps } = props;
  const history = useHistory();

  const { activeTab, goToTab } = useRootTab();

  const handleOnClick = useCallback(() => {
    if (!doNotGoBack) {
      // https://developer.mozilla.org/en-US/docs/Web/API/History/state
      // This is the only reliable way to check if there is history in v5 react router
      if (window.history.state && window.history.state.key != null) {
        history.goBack();
      } else {
        goToTab(activeTab ?? NAV_ITEMS.home);
      }
    }
  }, [doNotGoBack, history, activeTab, goToTab]);

  return (
    <IconButton
      size="sm"
      data-cy={dataCy || 'back-button'}
      icon={<ArrowLeftLineIcon />}
      placement="left"
      onClick={handleOnClick}
      {...otherProps}
    >
      {label ?? 'Back'}
    </IconButton>
  );
}
